<template>
  <sf-modal v-if="modalOpen" size="s" @close="close">
    <template #title
      >{{ I18n.t('companies_overview.period_selection_new.title') }}
    </template>

    <template #body>
      <div class="sf-align-c sf-below-3">
        {{
          I18n.t(
            'companies_overview.period_selection_new.choose_the_most_recent'
          )
        }}
      </div>

      <div
        class="sf-grid sf-grid-gutter-none sf-grid-fluid"
        style="margin-top: -1px"
      >
        <div class="sf-level sf-level-between">
          <div
            :class="[
              periodSelection == 'financial_year'
                ? 'sf-bg-snow-light sf-period-selector-card__selected'
                : '',
            ]"
            class="sf-period-selector-card"
          >
            <label
              class="sf-pad-3 sf-align-c"
              for="period_selection_financial_year"
            >
              <div class="sf-form-check sf-form-check-rounded">
                <input
                  id="period_selection_financial_year"
                  v-model="periodSelection"
                  name="selection_strategy"
                  type="radio"
                  value="financial_year"
                />
                <div class="sf-form-check-content sf-align-c">
                  <div
                    v-dompurify-html="
                      I18n.t(
                        'companies_overview.period_selection_new.financial_year'
                      )
                    "
                    class="sf-pad-v-2 sf-period-name"
                  ></div>

                  <img :src="$imagesRequire('insights/financial_year.svg')" />

                  <div
                    class="
                      sf-below-2
                      sf-font-xs
                      sf-line-height-2
                      sf-pad-v-1
                      sf-period-description
                      sf-pad-h-2
                    "
                  >
                    {{
                      I18n.t(
                        'companies_overview.period_selection_new.financial_period_description'
                      )
                    }}
                  </div>
                  <div class="sf-form-check-indicator sf-inline-block"></div>
                </div>
              </div>
            </label>
          </div>
          <div
            :class="[
              periodSelection == 'accounting_period'
                ? 'sf-bg-snow-light sf-period-selector-card__selected'
                : '',
            ]"
            class="sf-period-selector-card"
          >
            <label
              class="sf-pad-3 sf-align-c"
              for="period_selection_accounting_period"
            >
              <div class="sf-form-check sf-form-check-rounded">
                <input
                  id="period_selection_accounting_period"
                  v-model="periodSelection"
                  name="selection_strategy"
                  type="radio"
                  value="accounting_period"
                />
                <div class="sf-form-check-content sf-align-c">
                  <div
                    v-dompurify-html="
                      I18n.t(
                        'companies_overview.period_selection_new.accounting_period'
                      )
                    "
                    class="sf-pad-v-2 sf-period-name"
                  ></div>
                  <img
                    :src="$imagesRequire('insights/accounting_period.svg')"
                  />

                  <div
                    class="
                      sf-below-2
                      sf-font-xs
                      sf-line-height-2
                      sf-pad-v-1
                      sf-period-description
                      sf-pad-h-2
                    "
                  >
                    {{
                      I18n.t(
                        'companies_overview.period_selection_new.accounting_period_description'
                      )
                    }}
                  </div>
                  <div class="sf-form-check-indicator sf-inline-block"></div>
                </div>
              </div>
            </label>
          </div>
        </div>
        <div class="sf-align-c sf-pad-v-3">
          {{
            I18n.t(
              'companies_overview.period_selection_new.date_selection_step'
            )
          }}
        </div>

        <div class="sf-level-around tw-flex tw-justify-center">
          <div class="sf-pad-h-2 date-selector tw-w-80">
            <date-picker
              v-model="ledgerSelectDate"
              :icon="true"
              :placeholder="
                I18n.t(
                  'companies_overview.period_selection_new.date_selection_placeholder',
                  { date: currentDate }
                )
              "
              name="period"
            ></date-picker>
            <div v-show="v$.ledgerSelectDate.$error" class="sf-c-warning">
              {{ I18n.t('companies_overview.ledger_select_date_format_error') }}
            </div>
          </div>
        </div>
      </div>
    </template>

    <template #footer>
      <div
        :class="[validForSave ? '' : 'sf-disabled']"
        class="sf-btn sf-btn-success rs-save-period-selection sf-pad-h-4"
        @click.prevent="save"
      >
        {{ I18n.t('common.save') }}
      </div>
    </template>
  </sf-modal>
</template>

<script>
import { useVuelidate } from '@vuelidate/core'

import { SfModal } from '@app/shared/vue/components/sf-modal'
import DatePicker from '@app/shared/vue/components/form/date-picker'
import { SfTime } from '@app/adapters/time'

export default {
  components: {
    SfModal,
    DatePicker,
  },
  setup() {
    return {
      v$: useVuelidate(),
    }
  },
  data() {
    return {
      modalOpen: false,
      periodSelection: null,
      ledgerSelectDate: null,
      saveCallback: null,
    }
  },

  validations: {
    ledgerSelectDate: {
      dateFormat: (value) => {
        // Empty (to allow clearing date) or DD/MM/YYYY
        if (value === null || value === '') {
          return true
        }
        return /^\d{2}\/\d{2}\/\d{4}$/.test(value)
      },
    },
  },

  computed: {
    validForSave() {
      if (!this.periodSelection) {
        return false
      }

      return true
    },
    currentDate() {
      return SfTime(new Date()).format('DD/MM/YYYY')
    },
  },

  watch: {
    // Needed for vuelidate because it isn't triggered, probably because we pass it in v-model to datepicker
    ledgerSelectDate() {
      this.v$.ledgerSelectDate.$touch()
    },
  },

  methods: {
    // ModalCitizen interface
    openModal(data) {
      this.periodSelection = data.periodSelection
      this.ledgerSelectDate = data.ledgerSelectDate
      this.saveCallback = data.saveCallback
      this.modalOpen = true
    },

    close() {
      this.modalOpen = false
    },

    save() {
      this.saveCallback({
        periodSelection: this.periodSelection,
        ledgerSelectDate: this.ledgerSelectDate,
      })
      this.close()
    },
  },
}
</script>

<style lang="scss" scoped>
@import 'silverfin-ui-kit/src/scss/tooling';

.date-selector input::placeholder {
  @include color('text');
}

.sf-period-description {
  height: 40px;
}

.sf-period-name {
  font-size: 16px !important;
}

.sf-period-selector-card {
  border-radius: 8px;
  border: 1px solid var(--neutral-light-1, #cbcbcb);
  width: 265px;
}

.sf-period-selector-card__selected {
  border-color: #0aa1ba;
}

.date-selector-item__caret {
  position: absolute;
  left: auto;
  right: 100px;
}
</style>
